module.exports = __webpack_public_path__ + "img/MG_2624.db94be5f.jpg";